import React from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Radio,
  Typography,
} from '@mui/material';
import { Info } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PopupAdulto = ({
  showPopupAdulto,
  setShowPopupAdulto,
  escolhaCadastro,
  setEscolhaCadastro,
  setPrecisaResponsavel,
  setShowIJMForm,
  setShowIJMFormMenor,
  setIsNewUser,
  setUser,
  initialValues,
  setIdade,
  setResponsavelEncontrado,
  setMenorSelecionado,
  setIsUserVerified,
  setIsResponsavel,
  setMenoresVinculados,
  setUserHasPassword,
  setEnderecoConfirmado,
  setEtapaAtual,
}) => {
  const navigate = useNavigate();

  const resetFlow = () => {
    setShowPopupAdulto(false);
    setIsNewUser(false);
    setShowIJMForm(false);
    setShowIJMFormMenor(false);
    setUser(initialValues);
    setEscolhaCadastro(null);
    setPrecisaResponsavel(false);
    setIdade(null);
    setResponsavelEncontrado(null);
    setMenorSelecionado(null);
    setIsUserVerified(false);
    setIsResponsavel(false);
    setMenoresVinculados([]);
    setUserHasPassword(false);
    setEnderecoConfirmado(false);
    setEtapaAtual('login');
  };

  return (
    <Dialog
      open={showPopupAdulto}
      onClose={resetFlow}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Info color='info' />
          Idade não compatível com Mocidade
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity='info' sx={{ mb: 2 }}>
          Você tem 25 anos ou mais e não pode participar dos cursos de Mocidade.
        </Alert>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card
              sx={{
                p: 3,
                cursor: 'pointer',
                border: escolhaCadastro === 'menor' ? 2 : 1,
                borderColor:
                  escolhaCadastro === 'menor' ? 'primary.main' : 'divider',
                '&:hover': { borderColor: 'primary.main' },
              }}
              onClick={() => {
                setEscolhaCadastro('menor');
                setPrecisaResponsavel(true);
                setShowIJMFormMenor(true);
                setShowPopupAdulto(false);
              }}
            >
              <Box display='flex' alignItems='center' gap={2}>
                <Radio checked={escolhaCadastro === 'menor'} />
                <Box>
                  <Typography variant='h6' fontWeight='bold'>
                    Cadastrar um menor de idade
                  </Typography>
                  <Typography color='textSecondary'>
                    Registrar criança/jovem para IJM
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{
                p: 3,
                cursor: 'pointer',
                border: 1,
                borderColor: 'divider',
                '&:hover': { borderColor: 'primary.main' },
              }}
              onClick={() => {
                navigate('/lista-de-cursos');
                setShowPopupAdulto(false);
              }}
            >
              <Box display='flex' alignItems='center' gap={2}>
                <Radio checked={false} />
                <Box>
                  <Typography variant='h6' fontWeight='bold'>
                    Ver cursos tradicionais
                  </Typography>
                  <Typography color='textSecondary'>
                    Cursos para adultos em geral
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={resetFlow}>Cancelar</Button>
        <Button
          variant='contained'
          onClick={() => {
            setShowPopupAdulto(false);
            if (escolhaCadastro === 'menor') {
              setPrecisaResponsavel(true);
              setShowIJMForm(true);
            } else {
              navigate('/lista-de-cursos');
            }
          }}
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PopupAdulto;
